module.exports = __webpack_public_path__ + "static/media/logo.ed339f63.svg";